import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.scss']
})
export class AddLocationComponent implements OnInit {

  data;
  loading;
  error: any;
  constructor(public dialogRef: MatDialogRef<AddLocationComponent>, @Inject(MAT_DIALOG_DATA) public locData: any) {
    this.data = {
      title: ""
    }
  }

  noDataMsg = {
    title: "No Location!",
    data: "You have not yet added any locations"
  }

  ngOnInit() {
    console.log("Location", this.locData);

  }


  doAddNewLocation(data) {
    if (this.data.title == "") {
      console.log("Empty")
    }
    else {
      this.dialogRef.close(data);
    }
  }
  closeLocationModal() {
    this.dialogRef.close();
  }

  deletedLocation(id) {
    if (id.error) {
      this.error = id.error
    }
    else {
      this.locData.splice(this.locData.findIndex(function (i) {
        return i._id === id;
      }), 1);
    }
    console.log("IN LOCATION DELETE EVENt", id);
  }



}
